var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOilTower(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 31,
    viewBox: "0 0 20 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(0, 0, 0, 0.5)",
    fillRule: "nonzero",
    stroke: "rgba(0, 0, 0, 0.5)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M6.028 6L1 27M14 6l5 21M10 1v28.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13l5.011 1.264L15.523 13"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 4,
    d: "M5 6.275l5.011 1.78 5.512-1.78-5.512-2.522z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M6 3.759L9.81 5 14 3.759 9.81 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18l5.715 1.264L16 18M3 23.344l6.667 1.263L17 23.344"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilTower);
export default __webpack_public_path__ + "static/media/oil-tower.8290c75def30d92cd2158eaa4b2fb0c4.svg";
export { ForwardRef as ReactComponent };